const CHAT_BUBBLE_ELEMENT_ID = 'go-high-level-chat-bubble';

const removeChatBubbleElement = () => {
  const previousScript = document.getElementById(CHAT_BUBBLE_ELEMENT_ID);
  const chatWidget = document.querySelector(
    `chat-widget#${CHAT_BUBBLE_ELEMENT_ID}`,
  );
  if (chatWidget && previousScript) {
    previousScript.remove();
    chatWidget.remove();
  }
};

const addChatBubbleElement = (widgetId: string) => {
  const scriptElement = document.createElement('script');
  scriptElement.id = CHAT_BUBBLE_ELEMENT_ID;
  scriptElement.setAttribute('data-widget-id', widgetId);
  scriptElement.setAttribute(
    'src',
    'https://widgets.leadconnectorhq.com/loader.js',
  );
  scriptElement.setAttribute(
    'data-resources-url',
    'https://widgets.leadconnectorhq.com/loader.js',
  );
  document.body.appendChild(scriptElement);
};

const findChatBubbleElement = () => {
  return document.getElementById(CHAT_BUBBLE_ELEMENT_ID);
};

export const BubbleChatElement = {
  remove: removeChatBubbleElement,
  add: addChatBubbleElement,
  find: findChatBubbleElement,
};
